// extracted by mini-css-extract-plugin
module.exports = {"LoginButton":"ForgotPasswordRequestSuccess_LoginButton__3mXuS"};